import {
  KeyboardDatePicker, MuiPickersUtilsProvider
} from '@material-ui/pickers';
import MaterialTable from 'material-table';
import React, { useState } from 'react';
import { connect } from "react-redux";
import { UiActions } from 'state/actions/UiActions';
import { InfluencerPaymentActions } from 'state/actions/user/InfluencerPaymentActions';
import { tableIcons } from './TableIcons';
import { Helmet } from 'react-helmet';
import { GlamboxEndpoints } from 'core/glambox/GlamboxEndpoints';
import { ExecuteRequest } from 'core/glambox/GlamboxApi';
import { PartnerAdminActions } from 'state/actions/user/PartnerAdminActions';
import { Modal } from 'components/modal/Modal';
import { Utils } from 'utils/Utils';
import Styles from "components/admin/Campaigns.module.scss";


class DuvidasGlampartnersAdmin extends React.Component {
  constructor(props) {
    super(props);

    this.props.isAdmin(
      this.props.person.person.username,
      (response) => {
        const isAdmin = response.result;
        if (!isAdmin) {
          props.history.push("/");
        }
      });

    this.state = {
      questionsSent: [],
      files:[],
      filesVisible:false
    }
  }

  componentDidMount() {
    this.getQuestions();
  }

  getHeaders = () => {
    let headers = [
      { title: 'PersonId', field: 'personId', editable: 'never', hiddenByColumnsButton: true },
      { title: 'Date Created', field: 'dateCreated', editable: 'never', hiddenByColumnsButton: true,
        render: (rowData) => {
          return Utils.tempConvertDate(rowData.dateCreated)
        }
      },
      { title: 'Email', field: 'email', editable: 'never', hiddenByColumnsButton: true },
      { title: 'Help', field: 'help', editable: 'never', hiddenByColumnsButton: true },
      { title: 'Resolution Date', field: 'resolutionDate', editable: 'never', 
        render: (rowData) => {
          return rowData.resolutionDate ? Utils.tempConvertDate(rowData.resolutionDate) : null
        },
      hiddenByColumnsButton: true },
      { title: 'Departament', field: 'departament', hiddenByColumnsButton: true , 
        editComponent: props => {
        const options = [        
          'Influencers',
          'TI'
        ];
        return (
          this.renderStatusOptions(props, options)
        )
        }
      },
      { title: 'Type', field: 'type', editable: 'never', hiddenByColumnsButton: true },
      { title: 'Solved', field: 'solved',hiddenByColumnsButton: true 
        ,editComponent: props => {
          const options = [
            'false',
            'true'
          ];
          return (
            this.renderStatusOptions(props, options)
          )
      }},
      { title: 'Imagens', editable: 'never',
        render: (rowData) => {
          const { files, filesVisible } = this.state;
          return (
           <div>
              <Modal
                visible={filesVisible}
                onCloseModal={this.toggleFiles}>
                <div>
                  {files.length > 0 && files.map((item, key) => {
                    return (
                      <div className = {Styles["upload-files"]} 
                        key={key}>
                        <figure>
                          <img src={item.imageUrl} />  
                        </figure>       
                      </div>
                    );
                  })}
                </div>
              </Modal>
              <button //className={"btn btn-sm btn-light-pink"}
                onClick={() => {          
                  this.getFilesSent(rowData.helpId);
                  this.toggleFiles();
                }}>
                Ver imagens
              </button>
            </div>
          );
        }
      },
    ]

    return headers;
  }

  toggleFiles = () =>{    
      this.setState({ filesVisible: !this.state.filesVisible });    
  }

  renderStatusOptions = (props, options) => {
    return (
      <select onChange={(e) => props.onChange(e.target.value)}
        value={props.value}>
        {(() => {
          return options.map((value, key) => {
            return (
              <option value={value} key={key}>
                {value}
              </option>
            );
          });
        })()}
      </select>);
  }

  getQuestions = async () => {
    this.props.loaderShow();
    await ExecuteRequest(
      GlamboxEndpoints.Partner.getHelpSent,
      null,
      "GET",
      {
        'Authorization': this.props.token
      },
      null,
      (response) => {
        const {
          statusCode,
          result
        } = response;

        if (statusCode === 200) {
          this.setState({
            questionsSent: result
          })
        }
      }
    );

    this.props.loaderHide();
  }

  getFilesSent = async (currentHelpId) =>{
    await ExecuteRequest(
      GlamboxEndpoints.Partner.getHelpFilesSent,
      {
        'helpId': currentHelpId
      },
      "GET",
      {
        'Authorization': this.props.token
      },
      null,
      (response) => {
        const {
          statusCode,
          result
        } = response;

        if (statusCode === 200) {
          this.setState({
            files: result
          });
        }
      }
    )
  }

  renderQuestions = () => {
    const { questionsSent } = this.state;
    if (questionsSent.length < 1) return null;

    const editable = this.getEditable();
    return (
      <MaterialTable
        columns={this.getHeaders()}
        data={questionsSent}
        title="Dúvidas"
        editable={editable}
        options={{
          columnsButton: true,
          exportButton: true,
          exportAllData: true,
          actionsColumnIndex: -1
        }}        
        icons={tableIcons}
      />
    );

  }

  getEditable = () => {
    let editable = {
      onRowUpdate: (newData, oldData) => {
        return new Promise((resolve, reject) => {
          const { questionsSent } = this.state;
  
          let dataUpdate = [...questionsSent];
  
          for (const n in dataUpdate) {
            if (dataUpdate[n].personId === newData.personId) {
              dataUpdate[n] = Object.assign({}, dataUpdate[n], newData);
            }
          }
  
          const payload = this.getUpdatePayload(newData, oldData);
  
          this.updateData(payload, () => {
            resolve();
          });
        });
      },
      onBulkUpdate: (changes) => {
        return new Promise((resolve, reject) => {
          this.updateBulk(changes, () => resolve());
        });
  
      }
    }
    return editable;
  }

  getUpdatePayload = (newData, oldData) => {
    let payload = {
      departament: newData.departament, 
      helpId: oldData.helpId, 
      solved: newData.solved
    }  
    return payload;
  }

  updateData = async (payload, callback) => {
    await this.updateHelp(payload);
    callback();
  }

  updateHelp = async (payload) =>{
    ExecuteRequest(
      GlamboxEndpoints.Partner.updateHelp,
      Object.assign({}, payload),
      "PUT",
      {
        'Authorization': this.props.token
      },
      null,
      (response)=>{
        console.log(response)
      }
    )
  }

  updateBulk = (changes, callback) => {
    for (let n in changes) {
      let newData = changes[n].newData;
      let oldData = changes[n].oldData;

      const payload = this.getdUpdatePayload(newData, oldData);
      this.updateData(payload, callback);
    }
  }

  render() {
    const { questionsSent } = this.state;
    if (questionsSent.length < 1) {
      return (
        <div>
          Não foram enviadas dúvidas
        </div>
      )
    }
    return (
      <div className={"p-2 p-lg-5"}>
        <Helmet><title>Admin: Dúvidas</title></Helmet>

        <h1>Dúvidas enviadas</h1>
        {this.renderQuestions()}
      </div>
    );
  }

}

const mapStateToProps = (state) => ({
  store: state,
  person: state.person.data,
  partnerGeneral: state.partnerGeneral.data,
  token: state.token.data.Authorization

});

const mapDispatchToProps = (dispatch) => ({
  loaderShow: () => {
    dispatch(UiActions.loaderShow());
  },
  loaderHide: () => {
    dispatch(UiActions.loaderHide());
  },
  publishSuccessAlert: (message) => {
    dispatch(UiActions.publishSuccessAlert(message));
  },
  publishErrorAlert: (message) => {
    dispatch(UiActions.publishErrorAlert(message));
  },
  isAdmin: (email, callback) => {
    dispatch(PartnerAdminActions.isAdmin(email, callback));
  }
});

DuvidasGlampartnersAdmin = connect(
  mapStateToProps,
  mapDispatchToProps
)(DuvidasGlampartnersAdmin);

export {
  DuvidasGlampartnersAdmin
};
